<template>
    <dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
        <template v-slot:title>История обновлений</template>
        <template v-slot:content>
            <v-layout column :class = '`body-2 mt-1 mb-2 mx-4 ${!$vuetify.theme.dark? "black--text":""}`' align-start v-if = 'meta.schedule'>
                <span>Автоматическое обновление <b>{{meta.schedule.enabled? "включено": "отключено"}}</b></span>
                <span>График обновления: <b>{{meta.schedule.days && meta.schedule.days.length == 7? "ежедневно": "по дням"}}</b></span>
                <v-layout v-if = 'meta.schedule.days && meta.schedule.days.length != 7' row wrap align-center px-3>
                    <span>Дни обновления:</span>
                    <v-chip small label v-for = '(d,di) in meta.schedule.days' :key = 'di'>{{d}}</v-chip>
                </v-layout>
                <v-layout row wrap align-center px-3>
                    <span>Запланированное время:</span>
                    <kbd v-for = 't in meta.schedule.times' class = 'mx-1' :key = 't'>{{t}}</kbd>
                </v-layout>
            </v-layout>
            <v-divider></v-divider>
            <v-list class = 'text-start' v-if = 'meta.updates && meta.updates.length' style = 'width: 100%; max-height: 350px; overflow: scroll;'>
                <template v-for = "(refresh, ri) in meta.updates">
                    <v-list-item link :key = "ri" :id = "refresh.id" three-line>
                        <v-list-item-content>
                            <v-list-item-title>{{formatTime(refresh.endTime)}}</v-list-item-title>
                            <v-list-item-subtitle class = 'caption'>
                                Время обновления: <b>{{diffTime(refresh.endTime, refresh.startTime)}} мин.</b>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle class = 'caption'>Обновление <b>{{mappedRefreshTypes[refresh.refreshType]}}</b></v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action class = 'my-auto'>
                            <span class = 'mr-4'>
                                <v-icon color = 'success' v-if = 'refresh.status == "Completed"'>mdi-check-outline</v-icon>
                                <v-icon color = 'error' v-if = 'refresh.status == "Failed"'>mdi-close-outline</v-icon>
                                <v-icon color = 'info' v-if = 'refresh.status == "Unknown"'>mdi-progress-check</v-icon>
                                <v-icon color = 'error' v-if = 'refresh.status == "Disabled"'>mdi-alert-circle-outline</v-icon>
                            </span>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider :key = "refresh.id" v-if = 'ri + 1 != meta.updates.length'></v-divider>
                </template>
            </v-list>
        </template>
    </dialog-generic>
</template>

<script>

    import dayjs from 'dayjs'
    import 'dayjs/locale/ru'
    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

    export default {
        name: 'ReportScheduleController',
        props: ['report', 'meta', 'initialState'],
        components: {'dialog-generic': DialogGeneric},
        data() {
            return {
                visibility: this.initialState,
                indicator: false,
                indicatorSecondary: false,
                mappedRefreshTypes: {
                    'Scheduled': 'по расписанию',
                    'ViaApi': 'вручную',
                    'OnDemand': 'администратором'
                },
                mappedStatuses: {
                    'Unknown': 'Не определено',
                    'Completed': 'Успешно',
                    'Failed': 'Ошибка',
                    'Disabled': 'Заблокировано'
                }
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value;
            },
            visibility(value) {
                this.$emit('update:initialState', value);
                if (value) {
                    this.$dataLayer.$emit('enrich', {
                        event: 'interaction',
                        data: {
                            type: 'discover',
                            target: 'report_schedule'
                        },
                        once: false
                    })
                }
            }
        },
        methods: {
            diffTime(time1, time2) {
                return dayjs(time1).diff(dayjs(time2), 'minute')
            },
            formatTime(time) {
                return dayjs(time).format('D MMM YYYY, H:mm')
            },
            calculateDuration(time1, time2) {
                return dayjs(time1).diff(time2, 'minutes')
            }
        }
    }
</script>